import {ApiService} from "./api.service";
import {Injectable} from "@angular/core";

@Injectable()
export class DMenuService {
    constructor(private apiService: ApiService)
    {}

    public get(machineName)
    {
        return this.apiService.get('api/menu_items/'+machineName)
            .map((res) => {
                return ApiService.extractData(res);
            })
            .catch((err) => {
                return ApiService.handleError(err);
            });
    }
}


// WEBPACK FOOTER //
// D:/Documents/FTP/derma/dermabase.nl_backup/src/app/services/menu.service.ts